/** A8's section on a change set's page: its pending MCP revert requests (Apply / Reject for a person
 *  holding `console_notification_mcp_write`) and the MCP request it was applied from. Renders nothing
 *  for a change set without either. */
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import type { AIChangeDetail } from '@/api/aiChanges';
import { SectionCard } from '@/components/ReadView';

import { PendingChangeCard } from './PendingChangeCard';

export function PendingRequestsSection({ change }: { change: AIChangeDetail }) {
  const reverts = change.pending_reverts ?? [];
  const origin = change.from_pending_change ?? null;
  if (reverts.length === 0 && !origin) return null;
  return (
    <SectionCard title="MCP requests">
      {origin && (
        <Typography variant="body2" sx={{ mb: reverts.length ? 2 : 0 }} data-from-pending>
          Applied by {origin.decided_by?.email ?? 'a person'} from an MCP request by{' '}
          {origin.requested_by?.email ?? 'an unknown user'}
          {origin.proposal_id ? (
            <>
              {' '}
              (
              <RouterLink to={`/ai-changes/proposals/${origin.proposal_id}`}>
                review page
              </RouterLink>
              )
            </>
          ) : null}
          .
        </Typography>
      )}
      {reverts.map((p) => (
        <PendingChangeCard key={p.id} pending={p} />
      ))}
    </SectionCard>
  );
}
